'use client';

import { forwardRef, type HTMLAttributes } from 'react';

import { Skeleton } from '../../primitives/skeleton';
import { cn } from '../../utils/cn';

export interface UzSkeletonProps extends HTMLAttributes<HTMLDivElement> {
  /** Preset shapes for common loading states. */
  variant?: 'rect' | 'line' | 'circle' | 'title' | 'paragraph';
  /** Number of lines (only for variant='paragraph'). */
  lines?: number;
}

export const UzSkeleton = forwardRef<HTMLDivElement, UzSkeletonProps>(
  ({ variant = 'rect', lines = 3, className, ...rest }, ref) => {
    if (variant === 'paragraph') {
      return (
        <div ref={ref} className={cn('space-y-2', className)} {...rest}>
          {Array.from({ length: lines }).map((_, i) => (
            <Skeleton key={i} className={cn('h-3', i === lines - 1 ? 'w-2/3' : 'w-full')} />
          ))}
        </div>
      );
    }
    return (
      <Skeleton
        ref={ref}
        className={cn(
          variant === 'line' && 'h-3 w-full',
          variant === 'circle' && 'h-10 w-10 rounded-full',
          variant === 'title' && 'h-6 w-1/2',
          variant === 'rect' && 'h-24 w-full',
          className,
        )}
        {...rest}
      />
    );
  },
);
UzSkeleton.displayName = 'UzSkeleton';
